import { ReactNode } from 'react';
import { useAuthContext } from '../providers/AuthContext';
import { Redirect } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';

interface PageWrapperProps {
  pageTitle: string;
  children?: ReactNode;
}

const PageWrapper: React.FC<PageWrapperProps> = ({ pageTitle, children }) => {
  const { user } = useAuthContext();

  return user ? (
    <div className="flex-1 flex flex-col">
      <header className="border-b border-border bg-card/80 backdrop-blur-md pl-16 pr-6 py-4 lg:pl-6 sticky top-0 z-30">
        <div className="flex items-center justify-between">
          <h1 className="text-xl font-semibold tracking-tight text-foreground">{pageTitle}</h1>
          <ThemeToggle />
        </div>
      </header>
      <main className="flex-1 overflow-y-auto">
        {children}
      </main>
    </div>
  ) : (<Redirect to="/login" />);
};

export default PageWrapper;
